import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "7", cy: "7", r: "5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "17", cy: "17", r: "5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 17h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m3.46 10.54 7.08-7.08", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Tablets";
const Tablets = memo(themed(Icon));
export {
  Tablets
};
//# sourceMappingURL=tablets.js.map
